import React from 'react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

const Loading = ({ show }) => {
  if (show) {
    return (
      <>
        <Box
          width="100vw"
          height="100vh"
          position="fixed"
          top={0}
          left={0}
          zIndex={15}
          sx={{ opacity: 0.2, backgroundColor: 'black' }}
        ></Box>
        <Box
          position="fixed"
          zIndex={20}
          top="50%"
          left="50%"
          sx={{ transform: 'translate(-50%, -50%)' }}
        >
          <CircularProgress color="alternate" size={60} />
        </Box>
      </>
    )
  } else {
    return null
  }
}

export default Loading
